/**
 * Main store function
 */
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
//import DevTools from './../modules/App/components/DevTools'

const rootReducer = require(`../../projects/${process.env.APP_PROJECT}/redux/reducers`).default

export function configureStore(initialState = {}) {
  // Middleware and store enhancers
  const enhancers = [
    applyMiddleware(thunk),
  ]

  if (process.env.CLIENT && process.env.NODE_ENV === 'development') {
    // Enable DevTools only when rendering on client and during development.
    //enhancers.push(window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument());

    if (typeof window !== 'undefined') {
      enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
    }
  }

  const store = createStore(rootReducer, initialState, compose(...enhancers))

  // For hot reloading reducers
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept(`../../projects/${process.env.APP_PROJECT}/redux/reducers`, () => {
      const nextReducer = require(`../../projects/${process.env.APP_PROJECT}/redux/reducers`).default // eslint-disable-line global-require
      store.replaceReducer(nextReducer)
    })
  }

  return store
}
